export default {
    ordersLayout: {
        back: "ย้อนกลับ",
        emptyOrders: "คุณยังไม่มีคำสั่งซื้อ",
        loading: "กำลังโหลด",
        storeLabel: "ร้านค้า",
        totalLabel: "ยอดรวม",
        storeAddressPending: "ที่อยู่จะแสดงเร็วๆ นี้",
        productNameFallback: "สินค้า",
        ecListTitle: "คำสั่งซื้อของคุณ",
        ecStatusInStore: "สถานะ: ซื้อที่ร้าน",
        ecOrderNumber: "หมายเลขคำสั่งซื้อ: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} รายการ: รวม {{amount}}",
        ecCountTotalOther: "{{count}} รายการ: รวม {{amount}}",
        ecViewOrder: "ดูคำสั่งซื้อ >",
        ecViewOrderA11y: "ดูคำสั่งซื้อ {{order_number}}",
        ecBackToOrders: "กลับไปที่คำสั่งซื้อของคุณ",
        ecInStoreDate: "ซื้อที่ร้าน – {{date}}",
        ecProductsOne: "สินค้า",
        ecProductsOther: "สินค้า",
        ecSku: "รหัสสินค้า: {{sku}}",
        ecQty: "จำนวน: {{qty}}",
        ecWarrantyExpired: "หมดระยะรับประกัน",
        ecWarrantyActive: "อยู่ในระยะรับประกัน",
        ecSubtotalOne: "ยอดรวมย่อย – {{count}} รายการ",
        ecSubtotalOther: "ยอดรวมย่อย – {{count}} รายการ",
    }
}



// WEBPACK FOOTER //
// ./src/locales/th/index.js